
export const DotCircleSpinner = () => {
  return (
    <div className="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
  )
}
